import { EXPERIMENTS } from '../config';

const { control, treatment } = EXPERIMENTS.TOUR_AVAILABILITY.variations;

export const TOUR_AVAILABILITY_VARIATION_KEYS = Object.freeze([control, treatment]);

export function isTourAvailabilityTreatment(variationKey) {
  return variationKey === treatment;
}
